﻿window.initMainNavigation = (function () {
    var navItem = $('[data-dropdown-item="true"]')
    var body = $("body")

    function init() {
        body.removeClass(".mainnav-open")
        navItem.removeClass("is-active")

        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
            $(".main-nav-item", navItem).removeAttr("href")
            $(document).on("touchstart", ".mainnav-open", documentClickHandler)
            navItem.on("touchstart", navItemClickHandler)

            navItem.on("mouseenter", navItemMouseEnterHandler)
            navItem.on("mouseleave", navItemMouseLeaveHandler)
        } else {
            navItem.on("mouseenter", navItemMouseEnterHandler)
            navItem.on("mouseleave", navItemMouseLeaveHandler)
        }

        $(window).on('scroll', function () {
            if ($(document).scrollTop() > 0)
                $('.header').addClass('scrolled')
            else
                $('.header').removeClass('scrolled')
        })
    }

    function navItemMouseEnterHandler() {
        var el = $(this)
        el.addClass("is-active")
        body.addClass("mainnav-open")
    }

    function navItemMouseLeaveHandler() {
        var el = $(this)
        el.removeClass("is-active")
        body.removeClass("mainnav-open")
    }

    function navItemClickHandler(event) {
        var el = $(this)

        el.addClass("is-active").siblings(".is-active").removeClass("is-active")
        body.addClass("mainnav-open")
    }

    function documentClickHandler(event) {
        var el = $(event.target)
        var menuItem = el.closest(".is-active")

        if (menuItem.length <= 0 && $(event.target).closest(".header-main-subnav").length <= 0 && el.closest(".header-main-nav").length <= 0) {
            navItem.removeClass("is-active")
            body.removeClass("mainnav-open")
        }
    }

    return {
        init
    }
}())

window.initMainNavigation.init()
